module.exports = __webpack_public_path__ + "static/tavern-brawler-mtg_clb-35d535e74c53bb891222dc862a388092.webp";